module.exports = __webpack_public_path__ + "static/img/13.c00411d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/13.png
// module id = NHul
// module chunks = 0